// Environment variables configured in assets/envconf.js
declare var authority: string;
declare var baseUri: string;
declare var portalApi: string;
declare var notificationsApi: string;
declare var notificationsHub: string;
declare var catalogApi: string;
declare var assetsApi: string;
declare var referenceApi: string;
declare var oneHubApi: string;
declare var idpApi: string;
declare var autocareApi: string;
declare var autocareReferenceApi: string;
declare var searchApi: string;
declare var environmentLabel: string;
declare var environmentLabelVisible: boolean;
declare var idleTimeoutInMinutes: number;
declare var agGridLicenseKey: string;
declare var okta: boolean;
declare var oktaClientId: string;
declare var oktaDomain: string;
declare var cloudSsoEnabled: boolean;
declare var cloudSsoApplicationId: string;
declare var cloudSsoBaseUrl: string;
declare var cloudSsoInstanceId: string;
declare var cloudSsoProxy: string;
declare var cloudSsoFrontend: string;

export const environment = {
  production: /true/i.test('false'),
  environmentLabel: 'DEVOPS DEVELOP_20260601.1',
  environmentLabelVisible: /true/i.test('true'),
  idleTimeoutInMinutes: '480',
  agGridLicenseKey: 'Using_this_{AG_Grid}_Enterprise_key_{AG-111878}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{TecAlliance_GmbH}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{DIVWARE}_only_for_{11}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{DIVWARE}_need_to_be_licensed___{DIVWARE}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{14_December_2026}____[v3]_[01]_MTc5NzIwNjQwMDAwMA==abe693883821f50cb74a53cee5411fad',
  okta: /yes/i.test('yes'),
  oktaClientId: '0oa97ufzhoHdzNF470x7',
  oktaDomain: 'https://login.qa.tecalliance.cloud',
  cloudSsoEnabled: /yes/i.test('##{cloudSsoEnabled}##'),
  cloudSsoApplicationId: '##{cloudSsoApplicationId}##',
  cloudSsoBaseUrl: '##{cloudSsoBaseUrl}##',
  cloudSsoInstanceId: '##{cloudSsoInstanceId}##',
  cloudSsoProxy: '##{cloudSsoProxy}##',
  cloudSsoFrontend: '##{cloudSsoFrontend}##',

  services: {
    baseUri: 'https://cdn.devops.1one.tecalliance.net',
    authority: '',
    portalApi: 'https://devops.1one.tecalliance.net/apigw/portal',
    notificationsApi: 'https://devops.1one.tecalliance.net/apigw/notifications',
    notificationsHub: 'https://devops.1one.tecalliance.net/apigw/hubs/notifications',
    catalogApi: 'https://devops.1one.tecalliance.net/apigw/catalog',
    assetApi: 'https://devops.1one.tecalliance.net/apigw/asset',
    referenceApi: 'https://devops.1one.tecalliance.net/apigw/reference',
    oneHubApi: 'https://devops.1one.tecalliance.net/apigw/hub',
    idpApi: 'https://devops.1one.tecalliance.net/apigw/idp',
    autocareApi: 'https://devops.1one.tecalliance.net/apigw/autocare',
    autocareReferenceApi: 'https://devops.1one.tecalliance.net/apigw/autocarereference',
    searchApi: 'https://devops.1one.tecalliance.net/apigw/search',
  },
};
